module.exports = __webpack_public_path__ + "img/react-ecommerce2.fb74f2e1.png";